import React from 'react';

interface OpenWindowItem {
  id: string;
  title: string;
  type: string;
  isMinimized: boolean;
}

interface AppLauncherProps {
  activeRoleKey: string;
  openWindows: OpenWindowItem[];
  activeWindowId: string | null;
  onFocusWindow: (id: string) => void;
  onMinimizeWindow: (id: string) => void;
  onOpenApp: (appType: 'documents' | 'planilhas' | 'apresentacoes') => void;
}

const getWindowIcon = (type: string, title: string) => {
  if (type === 'MOBILE') {
    return (
      <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#3de5ff] fill-[#3de5ff]/15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
        <line x1="12" y1="18" x2="12.01" y2="18"/>
      </svg>
    );
  }
  if (type === 'FOLDER') {
    return (
      <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#ffb020] fill-[#ffb020]/15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 7.5A2.5 2.5 0 0 1 5.5 5H10l2 2h6.5A2.5 2.5 0 0 1 21 9.5v7A2.5 2.5 0 0 1 18.5 19h-13A2.5 2.5 0 0 1 3 16.5z" />
      </svg>
    );
  }
  if (type === 'OFFICE') {
    const isXls = title.endsWith('.xlsx');
    const isPpt = title.endsWith('.pptx');
    const color = isXls ? 'text-[#a6e3a1]' : isPpt ? 'text-[#f38ba8]' : 'text-[#89b4fa]';
    return (
      <svg viewBox="0 0 24 24" className={`w-4 h-4 ${color} fill-current/15`} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
        <polyline points="14 2 14 8 20 8"/>
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" className="w-4 h-4 text-[#cdd6f4]" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" />
    </svg>
  );
};

export const AppLauncher: React.FC<AppLauncherProps> = ({
  openWindows,
  activeWindowId,
  onFocusWindow,
  onMinimizeWindow,
}) => {
  return (
    <div className="flex items-center gap-2 select-none justify-center min-w-0">
      {openWindows.map((win) => {
        const isFocused = activeWindowId === win.id;

        return (
          <button
            key={win.id}
            onClick={() => {
              if (win.isMinimized) {
                onFocusWindow(win.id);
              } else if (isFocused) {
                onMinimizeWindow(win.id);
              } else {
                onFocusWindow(win.id);
              }
            }}
            className={`h-10 px-3.5 rounded-xl flex items-center gap-2 relative transition-all active:scale-95 cursor-pointer border ${
              isFocused
                ? 'bg-white/10 border-white/15 text-white shadow-lg'
                : 'bg-transparent border-transparent text-[#a6adc8] hover:bg-white/5 hover:text-white'
            } ${win.isMinimized ? 'opacity-55 hover:opacity-90' : 'opacity-100'}`}
          >
            <span className="flex items-center justify-center flex-shrink-0">
              {getWindowIcon(win.type, win.title)}
            </span>
            <span className="text-[10px] font-bold truncate max-w-[120px]" title={win.title}>
              {win.title}
            </span>

            {/* Active Indicator Underline Dot */}
            <span className={`absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full ${
              isFocused ? 'bg-[#3de5ff] shadow-[0_0_4px_#3de5ff]' : 'bg-white/40'
            }`} />
          </button>
        );
      })}
    </div>
  );
};
